/**
 * Reading a page's own URL and title to guess what the page is for.
 *
 * The site chose this open vocabulary, so it is genuinely external input.
 * Issue meaning is carried separately as typed semantic facts and is never
 * recovered here from Faro-generated prose.
 */

const ACTION_PATH =
  /(?:^|[\s/\-_])(apply|book|buy|cart|checkout|contact|demo|download|enquir|newsletter|purchase|quote|register|request|shop|sign-?up|subscribe)(?:$|[\s/\-_])/i;
const UTILITY_PATH =
  /(?:^|\/)(account|cookies?|legal|login|privacy|search|sitemap|terms)(?:\/|$)/i;

/** The page invites the visitor to do something. */
export function readsAsActionPage(pathAndTitle: ExternalText): boolean {
  return ACTION_PATH.test(pathAndTitle);
}

/** The page is site plumbing rather than part of a journey. */
export function readsAsUtilityPath(path: ExternalText): boolean {
  return UTILITY_PATH.test(path);
}

import type { ExternalText } from "contracts/boundaries/external-text";
